export default function ($q, SendStats) {
    'ngInject';

    return function () {
        const self = this;

        self.postQueryStatistic = function (searchTerm, correctedSearchTerm) {
            return SendStats.post({
                path: 'insert-query-statistic'
            },
            {
                q: searchTerm,
                c: correctedSearchTerm
            }).$promise;
        };
        
        self.postActivityStatistic = function (searchTerm, correctedSearchTerm, url, position) {
            return SendStats.post({
                path: 'insert-activity-statistic'
            },
            {
                q: searchTerm,
                c: correctedSearchTerm,
                du: url,
                dr: position
            }).$promise;
        };
    };
}


// WEBPACK FOOTER //
// ./src/search-interface/shared/services/statsService.js